import {
    Toolbar,
    AppBar as MuiAppBar,
    IconButton,
    Box,
    Badge,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountMenu from "./AccountMenu";
import { useImpersonation } from "@/layouts/components/layoutContext";
import BellMenu from "./BellMenu";
import OnboardingMenu from "./OnboardingMenu";
import { useRouter } from "next/router";
import RegulationsMenu from "./RegulationsMenu";
import { PROFILE } from "@/graphql/queries/profile";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export default function AppBar({ handleDrawerToggle, title, drawerWidth }) {
    const router = useRouter();
    const lessonNumber = router?.query?.lessonNumber;

    const [impersonated, _] = useImpersonation();

    const isFirstLesson = lessonNumber == -2;
    const displayOnboardingButton = lessonNumber < 5;
    const displayRegulationsButton = lessonNumber >= 5;

    const { data: { profile } = {} } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const isProfileFullFilled = profile?.meta?.isFullFilled ?? false;

    useEffect(() => {
        if (profile?.gender) {
            Sentry.setUser({
                id: profile?.userId,
                studentNumber: profile?.studentNumber,
            });
        }
    }, [profile]);

    return (
        <>
            <MuiAppBar
                component="nav"
                elevation={1}
                sx={{
                    position: { xs: "relative", sm: "absolute" },
                    // "&.MuiPaper-root": { top: impersonated ? "30px" : "0" },
                }}
            >
                <Toolbar
                    sx={{
                        display: "flex",
                        justifyContent: { xs: "space-between", sm: "end" },
                        alignItems: "center",
                        backgroundColor: "white",
                    }}
                >
                    <IconButton
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: "none" } }}
                        color="gray"
                        size="large"
                    >
                        {!isProfileFullFilled && (
                            <Badge
                                variant="dot"
                                max={99}
                                color="error"
                                overlap="rectangular"
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                sx={{ marginBottom: "10px" }}
                            ></Badge>
                        )}
                        <MenuIcon />
                    </IconButton>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: {
                                xs: "100%",
                                sm: `calc(100% - ${drawerWidth}px)`,
                            },
                        }}
                    >
                        <h4 className="text-base text-[#333] p-0 m-0 mt-1">
                            {title}
                        </h4>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            {displayRegulationsButton && <RegulationsMenu />}
                            {displayOnboardingButton && (
                                <OnboardingMenu isFirstLesson={isFirstLesson} />
                            )}
                            <BellMenu />
                            <AccountMenu />
                        </Box>
                    </Box>
                </Toolbar>
            </MuiAppBar>
        </>
    );
}
